import { render, staticRenderFns } from "./GlobalAlertModal.vue?vue&type=template&id=7135f899&"
import script from "./GlobalAlertModal.vue?vue&type=script&lang=js&"
export * from "./GlobalAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports